import * as React from "react";
import visualSearchFactory from "./visualSearch.factory";

const withProviderGallery = WrappedComponent => {
  return (props) =>
  <WrappedComponent {...props}>
    {({ provider, images, removeInvalidImage, isFetchingData }) => visualSearchFactory(provider, images, removeInvalidImage, isFetchingData)}
  </WrappedComponent>
};

export default withProviderGallery;


// WEBPACK FOOTER //
// ./src/modules/AdHocTools/VisualSearch/components/withProviderGallery.tsx